import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import Hero from "../../components/accomodation/hero/Hero";
import { IMAGES } from "../../data/images";
import promise1 from "../../assets/images/promise1.webp";
import promise2 from "../../assets/images/promise2.webp";
import promise3 from "../../assets/images/promise3.webp";
import Promise from "../../components/accomodation/promise/Promise";
import Working from "../../components/accomodation/working/Working";
import Faq from "../../components/accomodation/faq/Faq";
import Service from "../../components/visa/service/Service";
import Visahelp from "../../components/visa/help/Visahelp";
import img from "../../assets/images/visa/visahelp.webp";
import Permanent from "../../components/visa/permanent/Permanent";
import image from "../../assets/images/visa/permanent.webp";
import image2 from "../../assets/images/visa/permanent2.webp";
import DreamDestination from "../../components/visa/destination/DreamDestination.js";
import { FAQS } from "../../data/faqs";

function Visa() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div>
        <Header />
        <Hero
          img={IMAGES.visaAssistance}
          heading="Student Visa Assistance"
          description="Our experienced and free support will help you navigate through the complexities of visas and immigration requirements."
        />
        <Service
          heading="Student Visa Services"
          para="In the final step of your study abroad application, you must apply for student visa, which implies that you are eligible to travel to a particular country to pursue your intended studies. The process of applying for a student visa can be complicated. We can act as your guide and help you get the student visa with precision, if you don't know what to do. The requirements for obtaining the visa vary from country to country. The visa officers check the authenticity of your documents and your financial ability to study in a particular country. Usually, the visa officers are interested in evaluating your candidature, your motivation for studying abroad, and how you will manage life abroad. Our experience has given us insight into the reasons for visa rejections. You can avoid the most common or even the most challenging mistakes with our help. Additionally, we have helped many students who had their visa applications rejected. Following the best practices will not only ensure that you receive your visa approval quickly, but you will also have peace of mind."
        />
        <Promise
          heading="Here's How Ever Sky Can Help You"
          description=""
          promises={promises}
        />
        <Working data={workingData} />
        <Visahelp
          data={visaOptions}
          heading="Additional Visa Services"
          img={img}
        />
        <Permanent
          backgroundColor="rgb(248 250 252)"
          flexDirection="row"
          permanentData={permanentData}
          image={image}
        />
        <Permanent
          backgroundColor="var(--white)"
          flexDirection="row-reverse"
          permanentData={permanentData2}
          image={image2}
        />
        <DreamDestination />
        <Faq data={FAQS.visa} />
        <div className="text-center py-8">
          <button
            onClick={() => navigate("/pricing")}
            className="bg-blue-600 text-white py-3 px-8 rounded-lg hover:bg-blue-700 font-semibold"
          >
            Get Visa Assistance — ₹7,999
          </button>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Visa;

const promises = [
  {
    image: promise1,
    title: "Perfect Homes",
    description:
      "All our accommodations meet the highest safety and hygiene standards and offer an excellent living experience.",
  },
  {
    image: promise2,
    title: "Perfect Service",
    description:
      "Experience our world-class customer service available 24/7. Our customer service is unparalleled.",
  },
  {
    image: promise3,
    title: "Perfect Prices",
    description:
      "We offer best accommodation deals, with best prices across all the services.",
  },
  {
    image: promise1,
    title: "Perfect Homes",
    description:
      "All our accommodations meet the highest safety and hygiene standards and offer an excellent living experience.",
  },
  {
    image: promise2,
    title: "Perfect Service",
    description:
      "Experience our world-class customer service available 24/7. Our customer service is unparalleled.",
  },
  {
    image: promise3,
    title: "Perfect Prices",
    description:
      "We offer best accommodation deals, with best prices across all the services.",
  },
];

const workingData = [
  {
    heading: "Student Document Checklist",
    description: "",
  },
  {
    heading: "Verification of Student Documents",
    description: "",
  },
  {
    heading: "Application Process for Study Abroad",
    description: "",
  },
  {
    heading: "Preparing for a Study Abroad Interview",
    description: "",
  },
];

const visaOptions = [
  {
    heading: "Visitor visa",
    description:
      "We can assist you in applying for a visitor visa. Having offices at both ends of the process, we offer high-quality service in the region. This option allows you to invite your friends and family to visit you in Canada.",
  },
  {
    heading: "Parent and grandparent super visa",
    description:
      "A super visa is available for parents and grandparents to come to Canada based on their family relationship with their child or grandchild. We can help you in applying for this visa. This visa is valid for visits above six months and up to five (At present, it is mentioned two years).",
  },
  {
    heading: "Convocation visa",
    description:
      "A graduation ceremony is a memorable event for all students. Do you want your parents or siblings to be near you when you graduate from Canada? Our firm can help you apply for this visa on behalf of your parents/siblings",
  },
];

const permanentData = {
  heading: "Permanent Residency for Canada",
  description:
    "Canada wants to attract skilled and talented individuals, to bolster the economy. To do so, the country has created several programs that allow skilled professionals to immigrate. We can help you in applying to Canada's provincial nominee programs (PNPs) or Express Entry visas.",
  subheading: "As a Canadian Permanent Resident, you:",
  bulletPoints: [
    "Can apply for Canadian citizenship, after three years of being a permanent resident",
    "Are allowed to work in Canada without having to apply for a work permit",
    "Can sponsor their spouse, common-law partner and their dependent children to immigrate.",
    "Have access to Canada's public health care system",
  ],
  buttonText: "Talk to a PR Consultant",
};

const permanentData2 = {
  heading: "Student Visa Refusal Cases",
  description:
    "If your student visa is refused, we can help you in re-filing it and we have thousands of success stories in this regard! You can apply for a permanent residency after you complete your study in Canada, and we will assist you with that too. Our visa consultants will",
  subheading: "",
  bulletPoints: [
    "Understand the reason for the rejection (There are over 40!)",
    "Discuss your options with you, including alternative visa options",
    "Find the most suitable visa option for you and make the application.",
    "Deal with your student records (if needed) and your transcripts (if needed)",
    "Reapply with the visa office",
  ],
  buttonText: "Talk to a PR Study Abroad Counsellor->",
};
